module.exports = __webpack_public_path__ + "img/wxpay.0676e47c.png";